import React from "react"
import { Link } from "react-router-dom"


const SrNo = cell => {
  return (
    <Link to="#" className="text-body fw-bold">
      {cell.value ? cell.value : ""}
    </Link>
  )
}
const City = cell => {
  return cell.value ? cell.value : ""
}

const RTONO = cell => {
    return cell.value ? cell.value : ""
}

export {SrNo, City, RTONO}